import React from "react";
import set from "@rill/set";
import { useTranslation } from "react-i18next";
import SupportNav from "../../../parts/support-nav";

function View(props) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="Main Support-Articles">
      <SupportNav />

      <div className="Content">
        <div className="Articles">
          <div className="item">
            <div
              className="image"
              style={{ backgroundImage: "url(/img/support/article-1.webp)" }}
            ></div>
            <div className="title">{t("supportArticles.article1Title")}</div>
            <a
              href="http://www.mystrengthbook.com/blog-post/5749e469d697cf9a59c0a44f"
              target="_blank"
            ></a>
          </div>
          <div className="item">
            <div
              className="image"
              style={{ backgroundImage: "url(/img/support/article-2.webp)" }}
            ></div>
            <div className="title">{t("supportArticles.article2Title")}</div>
            <a
              href="http://www.mystrengthbook.com/blog-post/570422b03dd6f9631cff38e6"
              target="_blank"
            ></a>
          </div>
          <div className="item">
            <div
              className="image"
              style={{ backgroundImage: "url(/img/support/article-3.webp)" }}
            ></div>
            <div className="title">{t("supportArticles.article3Title")}</div>
            <a
              href="http://www.mystrengthbook.com/blog-post/57115a350ec867cc55886a40"
              target="_blank"
            ></a>
          </div>
          <div className="item">
            <div
              className="image"
              style={{ backgroundImage: "url(/img/support/article-4.webp)" }}
            ></div>
            <div className="title">{t("supportArticles.article4Title")}</div>
            <a
              href="http://www.mystrengthbook.com/blog-post/57115f34cac61c560aa385f6"
              target="_blank"
            ></a>
          </div>
        </div>
      </div>
    </div>
  );
}

const Articles = (app) => {
  app.get(
    "/articles",
    set("heading", "Articles"),
    ({ res }) => (res.body = <View />)
  );
};

export default Articles;
